let userPlatformHolder: string;

type NavigatorType = Navigator & {userAgentData?: {platform: string}};

if ((navigator as NavigatorType).userAgentData) {
    userPlatformHolder = (navigator as any).userAgentData.platform;
} else {
    userPlatformHolder = navigator?.platform;
}
const userPlatform = userPlatformHolder;

export const isMacOS = () => {
    return userPlatform.toUpperCase().indexOf('MAC') >= 0;
};

export const isDevEnv = (): boolean => {
    return (
        window.location.host === 'staging.priority-connect.online' ||
        window.location.host === 'd.priority-connect.online' ||
        window.location.host === 's.priority-connect.online' ||
        window.location.host === 'stageqa.priority-software.com' ||
        window.location.host === 'dev.eshbel.com' ||
        window.location.host.indexOf('127.0.0.1') > -1 ||
        window.location.host.indexOf('localhost') > -1
    );
};

export const getEnvType = (): string => {
    const url = window['MyGetURL']?.();
    if (url) {
        const urlData = new URL(url);
        const origin = urlData.origin;

        if (origin?.includes('/d.priority-connect.online')) return 'dev';
        else if (origin?.includes('/s.priority-connect.online')) return 'stage';
        else if (origin?.includes('/priority-connect.online')) return 'prod';
        else return 'farm:edp';
    }

    return '';
};

export const isDevOrPrisoft = (): boolean => {
    return (
        isDevEnv() ||
        window.location.pathname === '/webui/prisoft/' ||
        window.location.pathname === '/webui/pritest/'
    );
};

export const isDevEnvProcess = () => process.env.NODE_ENV === 'development';
